import React from 'react';
import { faqs } from '../../data/mock';
import { HelpCircle, ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQSection = () => {
  return (
    <section id="resources" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left - Header */}
          <div>
            <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">FAQs</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Frequently Asked <span className="text-[#4A90A4]">Questions</span>
            </h2>
            <p className="text-white/60 text-lg mb-8">
              Get answers to common questions about SR&ED and innovation funding. Don't see your question? Reach out to our team.
            </p>
            
            {/* Quick Stats */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="bg-white/5 border border-white/10 p-5">
                <div className="text-3xl font-bold text-[#4A90A4]">$10M+</div>
                <div className="text-white/50 text-sm">Funding Recovered</div>
              </div>
              <div className="bg-white/5 border border-white/10 p-5">
                <div className="text-3xl font-bold text-[#4A90A4]">98%</div>
                <div className="text-white/50 text-sm">Success Rate</div>
              </div>
            </div>

            <a
              href="#contact"
              className="group inline-flex items-center gap-3 bg-[#4A90A4] text-white px-6 py-3 font-medium hover:bg-[#5BA0B4] transition-all duration-300"
            >
              Ask Our Team
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
          </div>

          {/* Right - FAQs */}
          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-white/[0.02] border border-white/10 px-6 data-[state=open]:border-[#4A90A4]/30 data-[state=open]:bg-[#4A90A4]/5 transition-all duration-300"
                >
                  <AccordionTrigger className="text-white hover:text-[#4A90A4] text-left py-5 [&[data-state=open]>svg]:rotate-180">
                    <span className="flex items-center gap-3">
                      <HelpCircle size={18} className="text-[#4A90A4] flex-shrink-0" />
                      {faq.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 pb-5 pl-9 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
